import { useMediaQuery } from "react-responsive";

import { isWeb } from "~/lib/constants";

export const useMediaType = () => ({
  isWeb,
  isNative: !isWeb,
  isDesktop: useMediaQuery({
    minWidth: 729,
  }),
});

export const ResponsiveRenderer = ({
  webDesktop,
  web,
  default: defaultComponent,
}: {
  webDesktop?: React.ReactNode;
  web?: React.ReactNode;
  default: React.ReactElement;
}) => {
  const { isDesktop } = useMediaType();

  if (isDesktop && isWeb && typeof webDesktop !== "undefined") {
    return webDesktop;
  }

  if (isWeb && typeof web !== "undefined") {
    return web;
  }

  return defaultComponent;
};
